/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { EPermissionStatus } from '../../../core/models';
import { getRoadsideAssistanceVin, getUserPermissions } from '../../../core/store/selectors';

@Component({
  selector: 'fm-roadside-assistance-modal',
  templateUrl: './roadside-assistance-modal.component.html',
  styleUrls: ['./roadside-assistance-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoadsideAssistanceModalComponent implements OnInit {
  vin$: Observable<string>;
  hasVin$: Observable<boolean>;
  hasFullManageVehiclesPermission$: Observable<boolean>;
  roadsideAssistanceMicrositeUrl = environment.config.roadsideAssistanceMicrositeUrl;

  constructor(private readonly _store: Store) {}

  ngOnInit(): void {
    this.vin$ = this._store.pipe(select(getRoadsideAssistanceVin));
    this.hasVin$ = this.vin$.pipe(map(vin => !!vin));
    this.hasFullManageVehiclesPermission$ = this._store.pipe(
      select(getUserPermissions),
      map(permissions => permissions.manageVehicles === EPermissionStatus.Full)
    );
  }
}
